import { useQuery } from "@tanstack/react-query";
import { getIsAdmin } from "src/api/services/user/isAdminService";
import { useAuthContext } from "src/context/AuthContext";

export const useIsAdminQuery = () => {
  const { getValidToken } = useAuthContext();

  const {
    data: isAdmin = false,
    isLoading: isIsAdminLoading,
    isError: isIsAdminError,
  } = useQuery({
    queryKey: ["getIsAdmin"],
    queryFn: async () => {
      const token = await getValidToken();
      if (!token) throw new Error("Missing JWT token");

      const headers = { Authorization: `Bearer ${token}` };
      return getIsAdmin(headers);
    },
  });
  return { isAdmin, isIsAdminLoading, isIsAdminError };
};
